import React, { Component } from 'react'
import { Link } from 'react-router-dom'

class HoujinNewUser extends Component {
        constructor (props) {
            super(props)
            this.state = {
                username: '',
                password: '',
                password_confirmation: '',
                name: '',
                avatar: '',
                system_fee_per: '',
                role: 999,
                client: [],
                errors: [],
                roles: []
            }
            this.handleFieldChange = this.handleFieldChange.bind(this)
            this.handleCreate = this.handleCreate.bind(this)
            this.hasError = this.hasError.bind(this)
            this.renderError = this.renderError.bind(this)
            this.fireRedirect = this.fireRedirect.bind(this)
            this.confirmCreateUser = this.confirmCreateUser.bind(this)
        }
        
        componentDidMount () {
            axios.get('/api/roles_houjin').then(response => {
                this.setState({
                    roles: response.data
                })
            })
        }
        
        fireRedirect(e) {
            e.preventDefault()
            this.props.history.push(e.currentTarget.getAttribute('href'));
        }

        handleFieldChange (event) {
            this.setState({
                [event.target.name]: event.target.value
            }) 
        }

        handleCreate (event) {
            event.preventDefault()
            const { history } = this.props

            const newUser = {
              username: this.state.username,
              password: this.state.password,
              password_confirmation: this.state.password_confirmation,
              name: this.state.name,
              avatar: this.state.avatar,
              system_fee_per: this.state.system_fee_per,
              role: this.state.role
            }

            axios.post('/api/houjin_users', newUser)
            .then(response => {
                if(response.data.success){
                    $('#confirmModal').modal('hide');
                    this.props.history.push('/houjin_users');
                } else {
                    this.setState({
                        errors: response.data.errors
                    })
                }
            })
            .catch(error => {
                this.setState({
                    errors: error.response.data.errors
                })
            })
        }
        
        /**
        * Popup confirm create houjin user
        */
        confirmCreateUser(e) {
            e.preventDefault();
            const newUser = {
                username: this.state.username,
                password: this.state.password,
                password_confirmation: this.state.password_confirmation,
                name: this.state.name,
                avatar: this.state.avatar,
                system_fee_per: this.state.system_fee_per,
                role: this.state.role
            };
            //reset data
            this.setState({
                errors: [],
                client: []
            })
            //Handle check request only
            axios.post('/api/houjin_users/check_request', newUser)
            .then(response => {
                if(response.data.success){
                    this.setState({
                        client: response.data.client
                    })
                    $('#confirmModal').modal('show');
                } else {
                    this.setState({
                        errors: response.data.errors
                    })
                }
            })
            .catch(error => {
                this.setState({
                    errors: error.response.data.errors
                })
            })
        }

        hasError () {
            var count = 0;
            $.each(this.state.errors, function () {
                    count++;
            });
            return count;
        }

        renderError () {
            if (this.hasError()) {
                return (
                    <div className="alert alert-danger">
                        <ul className="reset-list">
                            {Object.keys(this.state.errors).map((key, i) => 
                                    <li key={i}>{this.state.errors[key]}</li>
                            )}
                        </ul>
                    </div>
                )
            }
        }

        render() {
            const client_status = {
                0: '未承認',
                1: '承認',
                8: 'アカウント停止',
                9: '否認'
            };
            return (
                <React.Fragment>
                    <div className="row">
                        <div className="col-sm-12">
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb mb-0">
                                    <li className="breadcrumb-item"><a onClick={this.fireRedirect} href="/home">ダッシュボード</a></li>
                                    <li className="breadcrumb-item"><a onClick={this.fireRedirect} href="/houjin_users">法人アカウント一覧</a></li>
                                    <li className="breadcrumb-item active" aria-current="page">法人アカウント登録</li>
                                </ol>
                            </nav>
                        </div>
                    </div>
                    <main id="main">
                        <div className="row justify-content-md-center">
                            <div className="col-sm-6">
                                <form className="form-horizontal">
                                    <div className="card mb-3">
                                        <div className="card-header p-4 border-bottom-0"><h4 className="mb-0">法人アカウント登録</h4></div>
                                        <div className="card-body">
                                                {this.renderError()}
                                                <div className="form-group row">
                                                        <label className="col-sm-4 col-form-label text-right" htmlFor="username">メールアドレス</label>
                                                        <div className="col-sm-8">
                                                                <input id="username" name="username" type="text" placeholder="" className="form-control" required onChange={this.handleFieldChange} value={this.state.username} />
                                                        </div>
                                                </div>
                                                <div className="form-group row">
                                                        <label className="col-sm-4 col-form-label text-right" htmlFor="password">パスワード</label>
                                                        <div className="col-sm-8">
                                                                <input id="password" name="password" type="password" placeholder="" className="form-control" onChange={this.handleFieldChange} />
                                                        </div>
                                                </div>
                                                <div className="form-group row">
                                                        <label className="col-sm-4 col-form-label text-right" htmlFor="password_confirmation">パスワード確認</label>
                                                        <div className="col-sm-8">
                                                                <input id="password_confirmation" name="password_confirmation" type="password" placeholder="" className="form-control" onChange={this.handleFieldChange} />
                                                        </div>
                                                </div>
                                                <div className="form-group row">
                                                        <label className="col-sm-4 col-form-label text-right" htmlFor="name">システム利用料(%)</label>
                                                        <div className="col-sm-8">
                                                                <input id="system_fee_per" name="system_fee_per" type="text" placeholder="" className="form-control" onChange={this.handleFieldChange} value={this.state.system_fee_per ? this.state.system_fee_per : ''} />
                                                        </div>
                                                </div>
                                                <div className="form-group row">
                                                        <label className="col-sm-4 col-form-label text-right" htmlFor="name">名前</label>
                                                        <div className="col-sm-8">
                                                                <input id="name" name="name" type="text" placeholder="" className="form-control" onChange={this.handleFieldChange} value={this.state.name} />
                                                        </div>
                                                </div>
                                                <div className="form-group row d-none">
                                                        <label className="col-sm-4 col-form-label text-right" htmlFor="avatar">アバター</label>
                                                        <div className="col-sm-8">
                                                                <input id="avatar" name="avatar" type="text" placeholder="" className="form-control" onChange={this.handleFieldChange} />
                                                        </div>
                                                </div>
                                                <div className="form-group row">
                                                        <label className="col-sm-4 col-form-label text-right" htmlFor="message">権限</label>
                                                        <div className="col-sm-8">
                                                                <select id="role" name="role" className="form-control" onChange={this.handleFieldChange} value={this.state.role}>
                                                                        {this.state.roles.map((item, v) => 
                                                                                <option key={v} value={item.id}>{item.name}</option>
                                                                        )}
                                                                </select>
                                                        </div>
                                                </div>
                                        </div>
                                        <div className="card-footer text-center">
                                            <input name="id" type="hidden" required onChange={this.handleFieldChange} value={this.state.id} />
                                            <button onClick={this.confirmCreateUser} className="btn btn-primary btn-radius btn-lg"><span className="size-inherit">確認する</span></button>
                                        </div>
                                    </div>
                                    <div className="modal fade" id="confirmModal" tabIndex="-1" aria-hidden="true">
                                        <div className="modal-dialog modal-dialog-centered" role="document">
                                            <div className="modal-content cover-loading-parent">
                                                <div className="modal-header">
                                                    <h5 className="modal-title" id="exampleModalLabel">法人アカウント情報を確認</h5>
                                                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                                        <span aria-hidden="true">&times;</span>
                                                    </button>
                                                </div>
                                                <div className="modal-body">
                                                    <div className="form-group row">
                                                        <div className="col-sm-4">依頼者メール</div>
                                                        <div className="col-sm-8">
                                                            {this.state.username}
                                                        </div>
                                                    </div>
                                                    <div className="form-group row">
                                                        <div className="col-sm-4">依頼者ID</div>
                                                        <div className="col-sm-8">
                                                            {this.state.client ? this.state.client.id : ''}
                                                        </div>
                                                    </div>
                                                    <div className="form-group row">
                                                        <label className="col-sm-4">依頼者名</label>
                                                        <div className="col-sm-8">
                                                            {(this.state.client && this.state.client.firstname && this.state.client.lastname) ? this.state.client.firstname+this.state.client.lastname : ''}
                                                        </div>
                                                    </div>
                                                    <div className="form-group row">
                                                        <label className="col-sm-4">システム利用料(%)</label>
                                                        <div className="col-sm-8">
                                                            {this.state.system_fee_per ? this.state.system_fee_per : ''}
                                                        </div>
                                                    </div>
                                                    <div className="form-group row">
                                                        <label className="col-sm-4">依頼者ステータス</label>
                                                        <div className="col-sm-8">
                                                            <span className="badge bg-pink text-white">{this.state.client ? client_status[this.state.client.status] : ''}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="card-footer text-center">
                                                    <button type="button" className="btn btn-secondary clearfix" data-dismiss="modal">キャンセル</button>
                                                    <button type="button" className="btn btn-primary" onClick={this.handleCreate}>登録する</button>
                                                </div>
                                                <div className="cover-loading block-hidden">処理中...</div>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </main>
                </React.Fragment>
            )
        }
}

export default HoujinNewUser